<template>
  <el-table-column
    prop="created_at"
    sortable="custom"
    label="Dátum"
    width="110"
    fixed
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.created_at | date }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'created_at',
  };
</script>

